/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Level_Tilt_BackInputs */

const en_us2_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilt the top of the phone back`)
};

const pt_br2_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incline o topo do celular para trás`)
};

const es_419_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclina la parte de arriba del teléfono hacia atrás`)
};

const pt_pt2_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclina o topo do telemóvel para trás`)
};

const fr_fr2_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incline le haut du téléphone vers l'arrière`)
};

const de_de2_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberkante des Handys nach hinten kippen`)
};

const it_it2_body_assessment_level_tilt_back = /** @type {(inputs: Body_Assessment_Level_Tilt_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclina la parte alta del telefono all'indietro`)
};

/**
* | output |
* | --- |
* | "Tilt the top of the phone back" |
*
* @param {Body_Assessment_Level_Tilt_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_level_tilt_back = /** @type {((inputs?: Body_Assessment_Level_Tilt_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Level_Tilt_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_level_tilt_back(inputs)
	if (locale === "es-419") return es_419_body_assessment_level_tilt_back(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_level_tilt_back(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_level_tilt_back(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_level_tilt_back(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_level_tilt_back(inputs)
	return en_us2_body_assessment_level_tilt_back(inputs)
});
export { body_assessment_level_tilt_back as "body-assessment.level_tilt_back" }